import { useEffect, useState } from "react";
import api from "./api";

// Server-backed liked-state cache (per logged-in member). Guests hold no state.
let likedIds = [];

export const getLikedIds = () => likedIds;

export const setLikedIds = (ids) => {
  likedIds = ids;
  window.dispatchEvent(new CustomEvent("kmu:data-changed"));
};

export const refreshLikedIds = async () => {
  try {
    const r = await api.get("/projects/likes/mine");
    likedIds = r.data.liked_ids || [];
  } catch {
    likedIds = [];
  }
  window.dispatchEvent(new CustomEvent("kmu:data-changed"));
};

export const clearLikedIds = () => {
  likedIds = [];
  window.dispatchEvent(new CustomEvent("kmu:data-changed"));
};

export function useLiked(id) {
  const [liked, setLiked] = useState(() => getLikedIds().includes(id));
  useEffect(() => {
    const sync = () => setLiked(getLikedIds().includes(id));
    sync();
    window.addEventListener("kmu:data-changed", sync);
    return () => window.removeEventListener("kmu:data-changed", sync);
  }, [id]);
  return liked;
}
